import Swal from "sweetalert2";

export default class SwalMessage {
  static errorMessage(error, title = false) {
    title = title || "Ops!";
    error = error || "Um problema aconteceu ao realizar esta ação.";

    Swal({
      type: "error",
      title,
      html: error,
      allowOutsideClick: false
    });
  }

  static warningMessage(warning, title = false) {
    title = title || "Atenção!";
    warning = warning || "Um problema aconteceu ao realizar esta ação.";

    return Swal({
      type: "warning",
      title: title,
      html: warning,
      allowOutsideClick: false
    });
  }

  static successMessage(success, title = false) {
    title = title || "Obrigado!";
    success = success || "";

    Swal({
      type: "success",
      title: title,
      html: success,
      allowOutsideClick: false
    });
  }

  static questionMessage(success, title = false) {
    title = title || "Atenção!";
    success = success || "";

    return Swal({
      type: "warning",
      title: title,
      html: success,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
      allowOutsideClick: false
    }).then(result => result);
  }

  static toastMessage(message, type = "warning", title = "Ops!") {
    message = message || "Um problema aconteceu ao realizar esta ação.";

    if (Swal.isVisible()) {
      Swal.close();
    }

    Swal({
      toast: true,
      type,
      title,
      text: message,
      position: "top-end",
      timer: 3000,
      showConfirmButton: false
    });
  }

  static isVisible() {
    return Swal.isVisible();
  }
}



// WEBPACK FOOTER //
// ./src/domain/message/SwalMessage.js